import React from 'react';

/**
 * Returns true when a click on an <a> should be handled by the app (in-page
 * navigation) rather than the browser. Modifier / non-left clicks (Cmd, Ctrl,
 * Shift, Alt, middle-click) are left to the browser so it can open the link in
 * a new tab / window natively.
 */
export function isPlainLeftClick(e: React.MouseEvent): boolean {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}
